import { API_BASE_URL } from '../config';

export async function submitPublicEnquiry(payload) {
  const response = await fetch(`${API_BASE_URL}/api/public/enquiries`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      ...payload,
      source_page: payload.source_page || window.location.pathname,
      website: '',
    }),
  });

  const result = await response.json().catch(() => ({}));
  if (!response.ok || result.success === false) {
    throw new Error(result.error || result.message || 'Unable to submit your request.');
  }
  return result;
}
